import { Card } from '@zorro/design-system/v2/Card';
import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { Grid, Space, Stack } from '@zorro/web/design-system';

const SectionHeader = () => <Skeleton h={12} w={290} />;

const EnrollmentColumn = () => (
  <Stack gap="var(--space-20)">
    <Skeleton h={12} w="100%" />
    <Skeleton h={12} w="100%" />
    <Skeleton h={12} w="100%" />
    <Skeleton h={12} w="100%" />
  </Stack>
);

export const CompanyOverviewSkeleton = () => {
  return (
    <Stack gap="var(--space-4)">
      <Stack gap="var(--space-16)">
        <Skeleton h={12} w={290} />
        <Skeleton h={12} w={202} />
      </Stack>
      <Space h="var(--space-32)" />

      <SectionHeader />
      <Space h="var(--space-16)" />
      <Grid>
        <Grid.Col span={4}>
          <Skeleton h={122} radius={12} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Skeleton h={122} radius={12} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Skeleton h={122} radius={12} />
        </Grid.Col>
      </Grid>
      <Space h="var(--space-32)" />

      <SectionHeader />
      <Space h="var(--space-16)" />
      <Card variant="white-border">
        <Grid>
          <Grid.Col span={4}>
            <EnrollmentColumn />
          </Grid.Col>
          <Grid.Col span={4} pl="var(--space-24)">
            <EnrollmentColumn />
          </Grid.Col>
          <Grid.Col span={4} />
        </Grid>
      </Card>
      <Space h="var(--space-32)" />

      <SectionHeader />
      <Space h="var(--space-16)" />
      <Grid>
        <Grid.Col span={4}>
          <Skeleton h={48} radius={12} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Skeleton h={48} radius={12} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Skeleton h={48} radius={12} />
        </Grid.Col>
      </Grid>
      <Space h="var(--space-32)" />
    </Stack>
  );
};
